import { useTranslation } from "react-i18next";
import heroImage from "../../assets/heroImage.png";
import heroImageRw from "../../assets/heroImageRW.png";
import { motion } from "framer-motion";
import { useAppContext } from "../../context";
import AppDownloadButtons from "../../components/downloadButtons";

export default function HeroSection() {
  const { t } = useTranslation();
  const { language } = useAppContext();

  return (
    <div
      className="pt-10 md:pt-20 bg-[rgb(0,73,69)] min-h-screen bg-radial-gradient"
      id="home"
    >
      <div className="container mx-auto px-6 pt-12 grid lg:grid-cols-2 gap-10 items-center">
        {/* Animate left side */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <h1 className="text-5xl font-bold text-white mb-14 leading-tight">
            {t("homePage.heading.1")}
            <br />
            {t("homePage.heading.2")}
          </h1>
          <p className="text-white/80 text-lg mb-12 ">
            {t("homePage.title.part1")} {t("homePage.title.part2")}{" "}
            {t("homePage.title.part3")} {t("homePage.paragraph")}.
          </p>
          {/* Download Buttons */}
          <div className="">
            <h3 className="text-white mb-4 uppercase tracking-wide font-semibold">
              {t("homePage.paragraph1")}
            </h3>
            <AppDownloadButtons />
          </div>
        </motion.div>
        {/* Animate hero image */}
        <motion.div
          className="relative"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, ease: "easeOut", delay: 0.3 }}
        >
          <div className="p-8 relative">
            <motion.img
              src={language === "en" ? heroImage : heroImageRw}
              alt="Happy user"
              className="w-full"
              transition={{
                duration: 3,
                ease: "easeInOut",
              }}
            />
          </div>
        </motion.div>
      </div>
    </div>
  );
}
